export class NoContentResult<T>
{
    constructor (public value: T, public noContent: boolean)
    {
    }
}
